import { illustrationNames } from '@/ui/illustrations/illustration/Illustration'
import { boolean, object, record, string, z } from 'zod'

/** TRICK: Zod's enum(...) expects 1 item at least */
const illustrationTuple = [illustrationNames[0]!, ...illustrationNames] as const

const FooterLinkSchema = object({
  name: string(),
  href: string(),
  targetBlank: boolean().optional(),
})

const FooterReassuranceSchema = record(
  string(),
  object({
    illustration: z.enum(illustrationTuple),
    href: string().optional(),
    line1: string(),
    line2: string().nullable(),
  }),
)

const FooterLinksSectionSchema = object({
  title: string(),
  links: record(string(), FooterLinkSchema),
  className: string().optional(),
})

const FooterFindUsSchema = object({
  title: string(),
  caption: string(),
  name: string().optional(),
})

const FooterAppDownloadSchema = object({
  title: string(),
  links: z.array(
    object({
      url: string(),
      alt: string(),
      storeIcon: string(),
    }),
  ),
})

const FooterSocialSchema = object({
  title: string(),
  links: z.array(
    object({
      url: string(),
      alt: string(),
      icon: z.enum(illustrationTuple),
    }),
  ),
})

const FooterLegalsSchema = object({
  links: record(string(), FooterLinkSchema),
}).default({ links: {} })

const FooterLinksSchema = object({
  aboutUs: FooterLinksSectionSchema.optional(),
  needHelp: FooterLinksSectionSchema.optional(),
  products: FooterLinksSectionSchema.optional().default({ title: '', links: {} }),
}).default({ aboutUs: undefined, needHelp: undefined, products: { title: '', links: {} } })

export const FooterSchema = object({
  footer: object({
    reassurance: FooterReassuranceSchema,
    findUs: FooterFindUsSchema,
    appDownload: FooterAppDownloadSchema.optional(),
    social: FooterSocialSchema.optional(),
    links: FooterLinksSchema.optional().default({ products: { title: '', links: {} } }),
    legals: FooterLegalsSchema.optional().default({ links: {} }),
  }),
})

export type FooterLinkProps = z.infer<typeof FooterLinkSchema>
export type FooterLinksSectionProps = z.infer<typeof FooterLinksSectionSchema>
export type FooterProps = z.infer<typeof FooterSchema>
export type FooterAppDownloadProps = z.infer<typeof FooterAppDownloadSchema>
export type FooterSocialProps = z.infer<typeof FooterSocialSchema>
